import { initialDoc } from './migrations/initial-doc';
import { sanitizeViews } from './migrations/sanitize-views';
import { templateId } from './migrations/template-id';

export const migrations = [initialDoc, templateId, sanitizeViews] as const;

export const clientDocVersion = migrations.length;
